/**
 * Safely evaluate conditional expressions (quantity > 100, type === 'acrylic', etc.)
 * Sanitizes input and uses constant context injection
 * @param {string} condition - Condition expression (e.g., "quantity > 100")
 * @param {object} context - Variables available in condition
 * @returns {boolean} Condition evaluation result (false on error)
 */
export default function createSafeConditionEvaluator(condition, context) {
  const createConditionEval = (cond, ctx) => {
    const sanitized = cond.replace(/[^a-zA-Z0-9._\s><=!&|()]/g, '');
    const variables = Object.keys(ctx)
      .map(k => `const ${k} = ${JSON.stringify(ctx[k])};`)
      .join('');
    try {
      // eslint-disable-next-line no-new-func
      return new Function(variables + `return ${sanitized}`)();
    } catch (e) {
      // console.warn(`Safe condition eval failed for "${cond}":`, e);
      return false;
    }
  };
  return createConditionEval(condition, context);
}
